import { useEffect, useState } from 'react';
import { shopApi } from './api';

const known = new Map<string, boolean>();

/**
 * Whether the Shop's orders and documents stay reachable for this user: the
 * app is active, or orders exist from before a deactivation. Deactivation
 * only stops new sales. `null` while unknown; an answer is asked at most once per tab.
 */
const useShopRetained = (restaurantId: string | null | undefined, active: boolean): boolean | null => {
  const initial = active ? true : restaurantId && known.has(restaurantId) ? (known.get(restaurantId) as boolean) : null;
  const [retained, setRetained] = useState<boolean | null>(initial);

  useEffect(() => {
    if (active) return setRetained(true);
    if (!restaurantId) return setRetained(false);
    if (known.has(restaurantId)) return setRetained(known.get(restaurantId) as boolean);
    let current = true;
    setRetained(null);
    shopApi.me(restaurantId).then(
      (capabilities) => {
        const value = capabilities.member && capabilities.hasOrders;
        known.set(restaurantId, value);
        if (current) setRetained(value);
      },
      () => {
        // A failed lookup is no answer: this view hides the Shop, the next one asks again.
        if (current) setRetained(false);
      }
    );
    return () => {
      current = false;
    };
  }, [restaurantId, active]);

  return retained;
};

export default useShopRetained;
